import { NewApplicationStatus, ReviewStatus } from '../types';

import cn from '../new-application.module.css';

const getStatusClassName = ({
  status,
  reviewStatus,
}: {
  status: NewApplicationStatus;
  reviewStatus?: ReviewStatus;
}) => {
  let reviewStatusText;
  let statusClassName = cn.incompleteStatus;

  if (status === NewApplicationStatus.DECLINED) {
    statusClassName = cn.declinedStatus;
  } else if (status === NewApplicationStatus.ACCEPTED) {
    statusClassName = cn.acceptedStatus;
  } else if (
    status === NewApplicationStatus.READY_TO_REVIEW ||
    status === NewApplicationStatus.REVIEW_IN_PROGRESS
  ) {
    statusClassName = '';
  }

  if (reviewStatus === ReviewStatus.NONE) {
    reviewStatusText = 'None';
  } else if (reviewStatus === ReviewStatus.ACCEPTED) {
    reviewStatusText = 'Accepted';
  } else if (reviewStatus === ReviewStatus.HAS_DUPLICATE) {
    statusClassName = cn.declinedStatus;
    reviewStatusText = 'Has Duplicate';
  } else if (reviewStatus === ReviewStatus.REJECTED) {
    reviewStatusText = 'Rejected';
  }

  return { statusClassName, reviewStatusText };
};

export default getStatusClassName;
